var render = function render(){var _vm=this,_c=_vm._self._c;return _c('esg-base-chart',[_c('loading',{attrs:{"active":_vm.loading,"z-index":1000,"is-full-page":false}}),_c('apex-chart',{ref:"chart",attrs:{"type":"donut","height":"250","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }